export default __webpack_public_path__ + "static/media/trash.053be648.svg";